var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgAssignmentTurned = function SvgAssignmentTurned(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.15 31.55 35 17.7l-2.15-2.15-11.7 11.7-6.05-6.05-2.1 2.1ZM9 39h30V9H9v30ZM9 9v30V9Zm0 33q-1.25 0-2.125-.875T6 39V9q0-1.25.875-2.125T9 6h10.25q.25-1.75 1.6-2.875T24 2q1.8 0 3.15 1.125Q28.5 4.25 28.75 6H39q1.25 0 2.125.875T42 9v30q0 1.25-.875 2.125T39 42ZM24 8.15q.7 0 1.225-.525.525-.525.525-1.225 0-.7-.525-1.225Q24.7 4.65 24 4.65q-.7 0-1.225.525-.525.525-.525 1.225 0 .7.525 1.225.525.525 1.225.525Z"
  })));
};

export { SvgAssignmentTurned as ReactComponent };
export default __webpack_public_path__ + "c513eee26fc2faf7334df9700ec6ece9.svg";